/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { addMinutes, format } from "date-fns";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Grid from "@mui/material/Grid";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";
// Functions from store
import {
  createDynamicColumn,
  getDynamicColumn,
  getRejectedTransactions,
  getRejectedTransactionsDownload,
  getSubModulesByRoleId,
} from "../../../store";

// React-Select component and styling

import "../../../index.css";

import Config from "../../../config/index";
// Cookies
import {
  Alert,
  Backdrop,
  CircularProgress,
  Collapse,
  Icon,
  IconButton,
  Modal,
  Tooltip,
} from "@mui/material";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDTypography from "components/MDTypography";
import { CSVLink } from "react-csv";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const RejectedTransaction = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getRejectedTransactions,
  getRejectedTransactionsReducer,
  getRejectedTransactionsDownloadReducer,
  getRejectedTransactionsDownload,
  getDynamicColumn,
  getDynamicColumnReducer,
  createDynamicColumn,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let jwtToken = loginDetails?.jwt;

  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  const subModuleId = "ad4ef1a3-9a6f-489a-8bc1-4f20808d1ae1";

  let rejectedTransactionModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "ad4ef1a3-9a6f-489a-8bc1-4f20808d1ae1",
  );

  // let viewAccess = rejectedTransactionModule
  //   ? rejectedTransactionModule.actionId.includes(
  //       "f720bf7d-488d-4f82-9f05-9caca4b8f3fe"
  //     )
  //   : null;

  let viewAccess = true;
  let downloadAccess = rejectedTransactionModule
    ? rejectedTransactionModule.actionId.includes(
        "1f12712b-f6a3-4596-8194-1434662f8ff6",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  useEffect(() => {
    getRejectedTransactions(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject, refresh]);
  useEffect(() => {
    getRejectedTransactionsDownload(
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    );
  }, [pageNo, rowsPerPage, searchObject, refresh]);

  const [state, setState] = useState({
    columns: [
      { Header: "Transaction code", accessor: "transactionCode" },
      { Header: "Item Code", accessor: "itemCode" },

      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },

      { Header: "Request Qty", accessor: "reqQty" },
      { Header: "Balance Qty", accessor: "balanceQty" },
      { Header: "To be Picked Qty ", accessor: "pckedQty" },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempAsset = [];
    let data = getRejectedTransactionsReducer.rejectedTransactions.data
      ? getRejectedTransactionsReducer.rejectedTransactions.data
      : [];
    setPaginationObj(
      getRejectedTransactionsReducer.rejectedTransactions?.pagination,
    );
    setLoading(getRejectedTransactionsReducer.loading);
    data.map((purchase) => {
      const formatDate = new Date(purchase.cd);
      let len = desLength;
      let des = purchase?.itemDescription;
      const purchaseObject = {
        privateKey: purchase.transactionId,
        transactionCode: purchase.transactionCode,
        itemCode: purchase.itemCode ? `${purchase.itemCode}` : "",

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {purchase?.itemDescription?.length > 35 ? (
              <Tooltip
                title={purchase.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {purchase.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {purchase.itemDescription}
              </MDTypography>
            )}
            {purchase?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        reqQty: `${purchase.requestQty}`,
        balanceQty: `${purchase.balanceQty}`,
        pckedQty: `${purchase.toBePickedQty}`,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: purchase.cd,
        // isEditable: purchase.isEditable,
      };
      viewAccess && tempAsset.push(purchaseObject);
    });

    setState({ ...state, rows: tempAsset });
  }, [getRejectedTransactionsReducer]);

  const [downloadData, setDownloadData] = useState("");
  useEffect(() => {
    let tempAsset = [];
    let data = getRejectedTransactionsDownloadReducer.rejectedTransactions.data
      ? getRejectedTransactionsDownloadReducer.rejectedTransactions.data
      : [];
    setPaginationObj(
      getRejectedTransactionsDownloadReducer.rejectedTransactions?.pagination,
    );
    setLoading(getRejectedTransactionsDownloadReducer.loading);
    data.map((purchase) => {
      const formatDate = new Date(purchase.cd);
      let len = desLength;
      let des = purchase?.itemDescription;
      const purchaseObject = {
        privateKey: purchase.transactionId,
        transactionCode: purchase.transactionCode,
        itemCode: purchase.itemCode ? `${purchase.itemCode}` : "",
        itemDescription: `${des ? des.substring(0, len) : ""}`,
        reqQty: `${purchase.requestQty}`,
        balanceQty: `${purchase.balanceQty}`,
        pckedQty: `${purchase.toBePickedQty}`,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        createdDate2: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        cd: purchase.cd,
        // isEditable: purchase.isEditable,
      };
      viewAccess && tempAsset.push(purchaseObject);
    });
    setDownloadData(tempAsset);
  }, [getRejectedTransactionsDownloadReducer]);
  const headers = [
    {
      label: "transactionCode",
      key: "transactionCode",
    },
    {
      label: "itemCode",
      key: "itemCode",
    },
    { label: "itemDescription", key: "itemDescription" },
    { label: "requestQty", key: "reqQty" },
    { label: "balanceQty", key: "balanceQty" },
    { label: "To be Picked Qty", key: "pckedQty" },
    {
      label: "createdDate",
      key: "createdDate2",
    },
  ];

  const csvLink = {
    filename: "Rejected Transaction List.csv",
    headers: headers,
    data: downloadData,
  };

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getRejectedTransactions(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };
  return (
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox color="text" px={2} ml={-2} mb={3}>
                {downloadAccess ? (
                  <CSVLink {...csvLink}>
                    <Tooltip title="Download Transaction List">
                      <MDButton
                        style={{ marginRight: "1rem", borderRadius: "5px" }}
                        size="small"
                        type="button"
                        variant="outlined"
                        color="success"
                        iconOnly
                      >
                        <Icon>download</Icon>
                      </MDButton>
                    </Tooltip>
                  </CSVLink>
                ) : (
                  ""
                )}
              </MDBox>
            </MDBox>

            <Grid item xs={12}>
              <MDBox pt={0}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    options={{ draggable: false }}
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      // onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getRejectedTransactionsReducer: state.getRejectedTransactionsReducer,
    getRejectedTransactionsDownloadReducer:
      state.getRejectedTransactionsDownloadReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getRejectedTransactions: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getRejectedTransactions(pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    getRejectedTransactionsDownload: (
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        getRejectedTransactionsDownload(
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RejectedTransaction);
